export const SENDER_TYPE = {
  USER: 'user',
  ASSISTANT: 'assistant',
} as const

export type SenderType = typeof SENDER_TYPE[keyof typeof SENDER_TYPE]
